import { formatDateShort } from "./format";

export function groupByDay(transactions, today = new Date()) {
  const todayKey = formatDateShort(today);
  const y = new Date(today.getFullYear(), today.getMonth(), today.getDate() - 1);
  const yesterdayKey = formatDateShort(y);
  const groups = [
    { label: "Hoy", items: [] },
    { label: "Ayer", items: [] },
    { label: "Anteriores", items: [] },
  ];
  for (const tx of transactions) {
    const k = formatDateShort(tx.date);
    if (k === todayKey) groups[0].items.push(tx);
    else if (k === yesterdayKey) groups[1].items.push(tx);
    else groups[2].items.push(tx);
  }
  return groups.filter((g) => g.items.length > 0);
}
